/* eslint-disable @typescript-eslint/no-explicit-any */
import { CSSProperties, Children, PureComponent, cloneElement } from 'react';
import { TransitionGroup } from 'react-transition-group';
import clsx from 'clsx';

import { mapValues } from 'es-toolkit/compat';
import { preventBubbleOutside } from '@tock/shared/utils/eventUtils';
import PopoverTransition from 'components/transitions/PopoverTransition';

export interface Props {
  align?: 'center' | 'end' | 'start' | 'right' | 'before';
  children?: React.ReactNode;
  childProps?: any;
  className?: string;
  style?: CSSProperties;
  isOpen: boolean;
  justify?: 'end' | 'start' | 'none';
  onClose(): void;
  position?: 'horizontal' | 'vertical';
}

interface PositionMapType {
  [placement: string]: string;
}

const alignMapping: PositionMapType = {
  center: 'Popover--alignCenter',
  end: 'Popover--alignEnd',
  start: 'Popover--alignStart',
  right: 'Popover--alignRight',
  before: 'Popover--alignBefore',
};

const justifyMapping: PositionMapType = {
  end: 'Popover--justifyEnd',
  start: 'Popover--justifyStart',
  none: 'Popover--justifyNone',
};

const positionMapping: PositionMapType = {
  horizontal: 'Popover--horizontal',
  vertical: 'Popover--vertical',
};

export default class Popover extends PureComponent<Props> {
  static defaultProps: Partial<Props> = {
    align: 'start',
    justify: 'end',
    position: 'vertical',
  };

  render() {
    const { align, childProps, children, className, isOpen, justify, position, style, onClose } =
      this.props;

    const alignClassName = alignMapping[align as string];
    const justifyClassName = justifyMapping[justify as string];
    const positionClassName = positionMapping[position as string];

    const clonedChildren = Children.toArray(children).map((child: any) => {
      const mappedChildProps = mapValues(childProps, (childProp) => {
        return (...argumentSpread: any[]) => {
          childProp(...argumentSpread);
          onClose();
        };
      });

      return cloneElement(child, {
        ...mappedChildProps,
      });
    });

    const componentClassName = clsx(
      'Popover',
      alignClassName,
      className,
      justifyClassName,
      positionClassName
    );

    return (
      <div onClick={preventBubbleOutside} style={style}>
        <TransitionGroup className={componentClassName}>
          <PopoverTransition isVisible={isOpen}>
            <div className="Popover-content">{clonedChildren}</div>
          </PopoverTransition>
        </TransitionGroup>
      </div>
    );
  }
}
